<template>
  <div class="pool-paras">

    <div v-for="item in paraArray">
      <!--    实时数据，水温，PH，ORP等 -->
      <div class="para-item">
        <div class="para-name">{{ item.name }}</div>
        <div class="value clickable" v-if="setValue" @click="clickValue(item)">{{ item.value || "-" }}</div>
        <div class="value" v-else>{{ item.value || "-" }}</div>
        <div class="unit">{{ item.unit }}</div>
      </div>

      <div class="para-item" v-if="setRange && item.rangeDataId">
        <div class="para-name">设定{{ item.name }}</div>
        <div class="range">
          <div class="range-value clickable" @click="clickRange(item,0)">{{getValue(item.rangeDataId[0])}}</div>
          -
          <div class="range-value clickable" @click="clickRange(item,1)">{{getValue(item.rangeDataId[1])}}</div>
        </div>
      </div>

    </div>

    <InputDialog ref="inputDialog"></InputDialog>

  </div>
</template>

<script>
import RowItem from "./RowItem"
import InputDialog from "@/components/dialog/InputDialog";

export default {
  components: {RowItem,InputDialog},
  props: ["valueMap", "paraArray", "setValue", "setRange"],
  methods:{
    getValue(dataId){
      return this.valueMap[dataId] || "-"
    },
    clickRange(item,index){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定"+item.name,
        onOk(value) {
          let dataId = item.rangeDataId[index]
          that.control(dataId, value)
        }
      })
    },
    clickValue(item){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定"+item.name,
        value: item.value,
        onOk(value) {
          let dataId = item.dataId
          that.control(dataId, value)
        }
      })
    },
    control(key, value) {
      this.$emit("control", key, value)
    }
  }
}
</script>

<style lang="less" scoped>
.pool-paras {
  display: flex;
  align-items: center;
  justify-content: space-between;


  .para-item {
    position: relative;
    background: #03417B;
    width: 12vw;
    text-align: center;
    border-radius: 10px;
    overflow: hidden;
    color: #FFF;

    .para-name {
      background: #063366;
      font-size: 1.2vw;
      padding: 0.2vw;
    }

    .value {
      font-size: 4vw;
      margin-bottom: 0.5vw;
    }

    .unit {
      position: absolute;
      bottom: 5px;
      right: 10px;
      text-align: center;
      font-size: 1vw;
    }

    .range{
      font-size: 1.4vw;
      display: flex;
      align-items: center;
      justify-content: center;

      .range-value{
        margin: 10px;
        cursor: pointer;
        min-width: 2vw;
      }
    }
  }

}
</style>
